import { apiClient } from './api';
import type { AgeAttestationSelection, CompleteWebOnboardingPayload } from '../types';

export async function recordWebAgeAttestation(selection: AgeAttestationSelection): Promise<{
  success: boolean;
  ageEligibilityStatus: string;
  adultAttestationCurrent: boolean;
  nextStep: string;
}> {
  const response = await apiClient.post(
    '/api/v1/web/onboarding/age-attestation',
    { selection }
  );
  return response.data;
}

export async function acceptWebLegalConsent(): Promise<{ success: boolean; legalConsentRecorded: boolean }> {
  const response = await apiClient.post<{ success: boolean; legalConsentRecorded: boolean }>(
    '/api/v1/web/onboarding/legal-consent',
    {}
  );
  return response.data;
}

export async function completeWebOnboarding(payload: CompleteWebOnboardingPayload) {
  const response = await apiClient.post('/api/v1/web/onboarding/complete', payload);
  return response.data;
}
